import { atom } from 'recoil';
import type { CoverableChangesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { coverableChangesSelector } from '../selectors/coverableChangesSelector';

export const coverableChangesAtom = atom<CoverableChangesDTO[]>({
    key: 'coverableChanges',
    default: coverableChangesSelector
});
